// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e238b210ea5e50c14500","655":"24c113adc9d72db893c7"}[chunkId] + ".js";
};